import { c as _c } from "react/compiler-runtime";
import { FormSelect, PrimaryButton } from '@systemeio/ui';
import { PhysicalOfferEditInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/physical-offer-interface';
import { usePhysicalProductsList } from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/hooks/use-physical-products-list';
import { FunnelInterface } from 'modules/funnels/funnel/types/funnel-interface';
import { getProductListData } from 'modules/funnels/funnel/utils/offer-configuration-utils';
import React, { useEffect, useState } from 'react';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { BoxIcon, SaveIcon } from '@systemeio/ui/icons';
interface PhysicalProductSelectorProps {
  funnel: FunnelInterface;
  product: PhysicalOfferEditInterface['product'];
  onSave: (data: PhysicalOfferEditInterface['product']) => Promise<void>;
}
function PhysicalProductSelector(t0) {
  const $ = _c(37);
  const {
    funnel,
    product,
    onSave
  } = t0;
  const [tempState, setTempState] = useState(product);
  const {
    physicalProductsList
  } = usePhysicalProductsList(funnel.currency);
  const {
    t
  } = useLocoTranslation();
  const [hasChanged, setHasChanged] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  let t2;
  if ($[0] !== product) {
    t1 = () => {
      setTempState(product);
    };
    t2 = [product];
    $[0] = product;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onSave || $[4] !== physicalProductsList || $[5] !== tempState) {
    t3 = async () => {
      if (!physicalProductsList) {
        return;
      }
      setIsFetching(true);
      await onSave(tempState);
      setHasChanged(false);
      setIsFetching(false);
    };
    $[3] = onSave;
    $[4] = physicalProductsList;
    $[5] = tempState;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleSave = t3;
  if (!physicalProductsList) {
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="flex h-full items-center justify-center py-12"><Loader className="scale-150" /></div>;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BoxIcon />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("dashboard.funnel.configuration.offer.physical_product");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className="text-brand-primary flex flex-row items-center gap-1 text-sm lg:text-[15px]">{t4}<span>{t5}</span></div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("dashboard.funnel.configuration.offer.physical_product_description");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <span className="text-sm font-normal">{t7}</span>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="flex flex-col gap-3">{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== physicalProductsList) {
    t10 = getProductListData(physicalProductsList);
    $[20] = physicalProductsList;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = tempState || undefined;
  let t12;
  if ($[22] !== tempState) {
    t12 = data => {
      setTempState(data ?? null);
      if (data !== tempState) {
        setHasChanged(true);
      }
    };
    $[22] = tempState;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12) {
    t13 = <FormSelect data={t10} className="sm:min-w-0" value={t11} onChange={t12} />;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== handleSave || $[29] !== hasChanged || $[30] !== isFetching || $[31] !== t) {
    t14 = hasChanged && <PrimaryButton width="large" onClick={e => {
      e.preventDefault();
      handleSave();
    }} isFetching={isFetching} type="submit" className="mr-auto"><SaveIcon />{t("global.save")}</PrimaryButton>;
    $[28] = handleSave;
    $[29] = hasChanged;
    $[30] = isFetching;
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14 || $[35] !== t9) {
    t15 = <div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-5">{t9}{t13}{t14}</div>;
    $[33] = t13;
    $[34] = t14;
    $[35] = t9;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
}
export default PhysicalProductSelector;